import {cleanEnv, str} from 'envalid';

const validatedEnv = cleanEnv(
  (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) || process.env,
  {
    REACT_APP_ENVIRONMENT: str({
      default: 'development',
      desc: 'Custom environment identifier for the app (e.g., "development", "staging", "production"). Used for runtime configuration.'
    }),
    REACT_APP_PROTOCOL: str({
      desc: 'Communication protocol with the server (e.g., "http", "https")',
      default: 'http'
    }),
    REACT_APP_HOST: str({
      desc: 'Host address and port where the app is running',
      default: 'localhost:3000'
    }),
    REACT_APP_VERSION: str({
      desc: 'Version of our app',
      default: '0.1.0'
    }),
    REACT_APP_IAM_HOST: str({
      desc: 'Host address of the authentication and authorization service',
      default: 'https://iam-dev.sportjoe.net'
    }),
    REACT_APP_IAM_REALM: str({
      desc: 'Realm for the IAM system',
      default: 'sportjoe'
    }),
    REACT_APP_IAM_CLIENT: str({
      desc: 'Client name for the IAM system',
      default: 'sjwebapp'
    }),
    REACT_APP_SERVER: str({
      desc: 'Main server address of the app',
      default: 'https://dev.sportjoe.net'
    }),
    REACT_APP_SERVER_ENDPOINT: str({
      desc: 'Endpoint prefix for server rest api',
      default: '/api/3'
    }),
    REACT_APP_SERVER_API_VERSION: str({
      desc: 'API version used by the app',
      default: '2'
    }),
    REACT_APP_APP_VARIANT: str({
      desc: 'App variant (might be used for different thematic/branded versions of the app)',
      default: 'sportjoe'
    }),
    REACT_APP_CONTENT_SERVER: str({
      desc: 'Server address for content storage (e.g., images, files)',
      default: 'https://s3.sportjoe.net/sportjoe/'
    }),
    REACT_APP_GOOGLE_MAPS_API_KEY: str({
      desc: 'API Key for the Google Maps service'
    }),
    REACT_APP_THEME_VARIANT: str({
      desc: 'Thematic variant of the app interface',
      default: 'sportjoe'
    }),
    REACT_APP_DEEPLINK_PREFIX: str({
      default: 'sportjoe'
    }),
    REACT_APP_STRIPE_PUBLISHABLE_KEY: str({
      default: 'your-stripe-key'
    }),
    REACT_APP_STRIPE_MERCHANT_IDENTIFIER: str({
      default: 'your-stripe-merchant-identifier'
    }),
    REACT_APP_MATRIX_SERVER_URL_SUFFIX: str({
      default: 'example.matrix.com'
    }),
    REACT_APP_MATOMO_CONTAINER_URL: str({
      default: 'your-matomo-container-url'
    }),
    REACT_APP_PUBLIC_COMPANIES: str({
      default: 'public-companies-object'
    }),
    REACT_APP_TAG_PAIRS: str({
      default: 'encoded-tag-pairs'
    }),
    REACT_APP_TERMS_OF_USE_URL: str({
      default: 'https://sportjoe.net/terms-of-use-mobile.html'
    }),
    REACT_APP_PRIVACY_POLICY_URL: str({
      default: 'https://sportjoe.net/mobile-privacy-policy.html'
    }),
    REACT_APP_LEGAL_INFORMATION_URL: str({
      default: 'https://www.sportjoe.net/legal-information.html'
    }),
    REACT_APP_DOWNLOAD_URL: str({
      default: 'https://sportjoe.net/download.html'
    }),
    REACT_APP_SHARE_URL_EVENT: str({
      default: 'https://www.sportjoe.net/eventRedirect.html?q='
    }),
    REACT_APP_SHARE_URL_GROUP: str({
      default: 'https://www.sportjoe.net/groupRedirect.html?q='
    }),
    REACT_APP_LINKEDIN_LINK: str({
      default: 'https://de.linkedin.com/company/covitaleu'
    }),
    REACT_APP_INSTAGRAM_LINK: str({
      default: 'https://www.instagram.com/sportjoeapp/'
    })
  }
);

export const env = {
  ENVIRONMENT: validatedEnv.REACT_APP_ENVIRONMENT,
  PROTOCOL: validatedEnv.REACT_APP_PROTOCOL,
  HOST: validatedEnv.REACT_APP_HOST,
  VERSION: validatedEnv.REACT_APP_VERSION,
  IAM_HOST: validatedEnv.REACT_APP_IAM_HOST,
  IAM_REALM: validatedEnv.REACT_APP_IAM_REALM,
  IAM_CLIENT: validatedEnv.REACT_APP_IAM_CLIENT,
  THEME_VARIANT: validatedEnv.REACT_APP_THEME_VARIANT,
  CONTENT_SERVER: validatedEnv.REACT_APP_CONTENT_SERVER,
  GOOGLE_MAPS_API_KEY: validatedEnv.REACT_APP_GOOGLE_MAPS_API_KEY,
  SERVER: validatedEnv.REACT_APP_SERVER,
  SERVER_ENDPOINT: validatedEnv.REACT_APP_SERVER_ENDPOINT,
  SERVER_API_VERSION: validatedEnv.REACT_APP_SERVER_API_VERSION,
  APP_VARIANT: validatedEnv.REACT_APP_APP_VARIANT,
  PUBLIC_COMPANIES: validatedEnv.REACT_APP_PUBLIC_COMPANIES,
  TAG_PAIRS: validatedEnv.REACT_APP_TAG_PAIRS,
  DEEPLINK_PREFIX: validatedEnv.REACT_APP_DEEPLINK_PREFIX,
  STRIPE_PUBLISHABLE_KEY: validatedEnv.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  STRIPE_MERCHANT_IDENTIFIER: validatedEnv.REACT_APP_STRIPE_MERCHANT_IDENTIFIER,
  MATRIX_SERVER_URL_SUFFIX: validatedEnv.REACT_APP_MATRIX_SERVER_URL_SUFFIX,
  MATOMO_CONTAINER_URL: validatedEnv.REACT_APP_MATOMO_CONTAINER_URL,
  TERMS_OF_USE_URL: validatedEnv.REACT_APP_TERMS_OF_USE_URL,
  PRIVACY_POLICY_URL: validatedEnv.REACT_APP_PRIVACY_POLICY_URL,
  LEGAL_INFORMATION_URL: validatedEnv.REACT_APP_LEGAL_INFORMATION_URL,
  DOWNLOAD_URL: validatedEnv.REACT_APP_DOWNLOAD_URL,
  SHARE_URL_EVENT: validatedEnv.REACT_APP_SHARE_URL_EVENT,
  SHARE_URL_GROUP: validatedEnv.REACT_APP_SHARE_URL_GROUP,
  LINKEDIN_LINK: validatedEnv.REACT_APP_LINKEDIN_LINK,
  INSTAGRAM_LINK: validatedEnv.REACT_APP_INSTAGRAM_LINK
};
